<template>
  <div class="page">
    <van-row justify="space-between">
      <van-col span="16">
        <van-space>
          <van-image width="60" height="60" src="/favicon.png" />
          <van-space direction="vertical" size="10" fill>
            <p class="text-color-desc" style="margin: 0;">合约管理</p>
            <p class="semibold text-title" style="margin: 0;">Contract Management</p>
          </van-space>
        </van-space>
      </van-col>
      <van-col span="8">
        <div class="wallet-info">
          <van-button 
            size="small"
            :type="isConnected ? 'success' : 'primary'"
            @click="isConnected ? null : connectWallet"
          >
            {{ isConnected ? '已连接' : '连接' }}
          </van-button>
        </div>
      </van-col>
    </van-row>

    <div class="content" style="margin-top: 20px;">
      <van-cell-group inset>
        <van-cell title="当前账户">
          <template #value>
            <span v-if="currentAccount">{{ formattedAccount }}</span>
            <span v-else>未连接</span>
          </template>
        </van-cell>

        <van-cell title="当前合约地址">
          <template #value>
            <span>{{ contractsAddress }}</span>
          </template>
        </van-cell>

        <van-cell title="当前Token价格">
          <template #value>
            <span>{{ tokenPrice }} USDT</span>
          </template>
        </van-cell>

        <van-field
          v-model="newTokenPrice"
          type="number" 
          label="Token价格"
          placeholder="请输入新的Token价格"
        />

        <van-button 
          block 
          type="primary" 
          color="#047857"
          @click="updateTokenPrice"
          style="margin-top: 20px;"
        >
          设置Token价格
        </van-button>

        <van-field
          v-model="usdtAmount"
          type="number" 
          label="授权USDT数量"
          placeholder="请输入授权USDT数量"
          style="margin-top: 20px;"
        />

        <van-button 
          block 
          type="primary" 
          color="#047857"
          @click="() => approveUsdt(usdtAmount)"
          style="margin-top: 10px;"
        >
          授权USDT
        </van-button>

        <van-button 
          block 
          type="primary" 
          color="#047857"
          @click="() => receiveDividends(usdtAmount)"
          style="margin-top: 10px;"
        >
          接受分红
        </van-button>

        <van-button 
          block 
          type="primary" 
          color="#047857"
          @click="() => distributeUndistributedDividends()"
          style="margin-top: 10px;"
        >
          分配未分配的分红
        </van-button>

        <van-button 
          block 
          type="danger"
          v-if="currentAccount"
          @click="handleDisconnect"
          style="margin-top: 10px;"
        >
          断开钱包
        </van-button>
      </van-cell-group>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import useWallet from '../composables/useWalletWagmi';
import Swal from 'sweetalert2';

const {
  currentAccount,
  connectWallet,
  disconnectWallet,
  setTokenPrice,
  getTokenPrice,
  tokenPrice,
  isConnected, // 添加isConnected状态
  approveUsdt, // 新增授权USDT的功能
  receiveDividends, // 新增接受分红的功能
  distributeUndistributedDividends, // 新增分配未分配的分红的功能
  contractsAddress
} = useWallet();

const newTokenPrice = ref('');
const usdtAmount = ref(''); // 新增授权USDT数量的状态

// 格式化账户地址
const formattedAccount = computed(() => {
  if (!currentAccount.value) return '';
  return `${currentAccount.value.slice(0, 10)}...${currentAccount.value.slice(-8)}`;
});

// 更新Token价格
const updateTokenPrice = async () => {
  if (!newTokenPrice.value) {
    Swal.fire({
      title: '错误',
      text: '请输入Token价格',
      icon: 'warning',
      confirmButtonText: '确定'
    });
    return;
  }

  try {
    await setTokenPrice(newTokenPrice.value * 1e6);
    await getTokenPrice(); // 更新价格后重新获取最新价格
    newTokenPrice.value = '';
  } catch (error) {
    console.error('设置Token价格失败:', error);
  }
};


// 断开钱包连接
const handleDisconnect = async () => {
  try {
    await disconnectWallet();
    Swal.fire({
      title: '成功',
      text: '钱包已断开连接',
      icon: 'success',
      confirmButtonText: '确定'
    });
  } catch (error) {
    console.error('断开钱包失败:', error);
  }
};

onMounted(async () => {
  await connectWallet();
  await getTokenPrice(); // 页面加载时获取Token价格
});

</script>
